import React, { useEffect, useState } from "react";
import { Button, Checkbox, List, Modal } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import TopBarHome from "../components/TopBarHome";
import conditionsImg from "./../assets/img/conditions.png"
import { DocInformativi } from "../utils/constants";
const { innerWidth, innerHeight } = window;

const ConditionScreen = () => {
    const navigate = useNavigate();
    const [conditionState, setConditionState] = useState();
    const [conditionTrasparenza, setConditionTrasparenza] = useState();
    const [conditionFEA, setConditionFEA] = useState();
    const [conditionPrivato, setConditionPrivato] = useState();
    const { state } = useLocation();

    useEffect(() => {
        if (!state) {
            if(localStorage.getItem("praticaTotem"))
            {
                localStorage.removeItem('praticaTotem');
                navigate('/homepage', { state: {isTotem: true}})
            }
            else
            {
                navigate('/homepage');
            }
        }
        if (state && !state.flg_privato) {
            setConditionPrivato(true);
        }
    }, [])

    const buttonHandler = () => {
        navigate('/onboarding');
    }

    const backHandler = () => {
        // if (state && state.vista_aggiuntiva) {
        //     navigate('/vista', { state: state });
        // } else {
            if(localStorage.getItem("praticaTotem"))
            {
                localStorage.removeItem('praticaTotem');
                navigate('/homepage', { state: {isTotem: true}})
            }
            else
            {
                navigate('/homepage');
            }
        // }
    }

    const onChange = (value) => {
        if (value.target.checked) {
            setConditionState(true);
        } else {
            setConditionState();
        }
    };

    const onChangeTrasparenza = (value) => {
        if (value.target.checked) {
            setConditionTrasparenza(true);
        } else {
            setConditionTrasparenza();
        }
    };

    const onChangeFea = (value) => {
        if (value.target.checked) {
            setConditionFEA(true);
        } else {
            setConditionFEA();
        }
    };

    const onChangePrivato = (value) => {
        if (value.target.checked) {
            setConditionPrivato(true);
        } else {
            setConditionPrivato();
        }
    };

    const requisitiModal = () => {
        if (state) {
            Modal.info({
                title: 'Requisiti',
                width: innerWidth < 500 ? '95%' : '60%',
                style: { maxWidth: 1000 },
                content: <div style={{ fontFamily: 'Poppins-Light', fontSize: 16, marginBottom: 20 }} dangerouslySetInnerHTML={{ __html: state.requisiti }}></div>,
                closable: true,
                maskClosable: true,
            });
        }
    };

    const trasparenzaModal = () => {
        Modal.info({
            title: 'Documenti Informativi',
            width: innerWidth < 500 ? '95%' : '50%',
            style: {
                maxWidth: 900,
            },
            content: (
                <div style={{ fontFamily: 'Poppins-SemiBold', fontSize: 16, maxHeight: '70vh', overflowY: 'auto' }}>
                    <List
                        style={{ marginTop: '2vh', color: '#0049EA', fontFamily: 'Poppins-Regular' }}
                        // header={<div>Documenti Informativi</div>}
                        dataSource={DocInformativi}
                        renderItem={(item) => (
                            <List.Item style={{ color: '#0049EA' }}>
                                - {item}
                            </List.Item>
                        )}
                    />
                </div>
            ),
            closable: true,
            maskClosable: true,
            okButtonProps: { style: { display: 'none' } }
        });
    };

    const condizioniModal = () => {
        if (state) {
            Modal.info({
                title: 'Condizioni',
                width: innerWidth < 500 ? '95%' : '60%',
                style: { maxWidth: 1000 },
                content: <div style={{ fontFamily: 'Poppins-Light', fontSize: 16, marginBottom: 20 }} dangerouslySetInnerHTML={{ __html: state.condizioni }}></div>,
                closable: true,
                maskClosable: true,
            });
        }
    };

    // const informativaModal = () => {
    //     if (state) {
    //         Modal.info({
    //             title: 'Informativa Privacy',
    //             width: '60%',
    //             style: { maxWidth: 1000, maxHeight:'800px', overflow:'auto' },
    //             content: <div style={{ fontFamily: 'Poppins-Light', fontSize: 16, marginBottom: 20 }} dangerouslySetInnerHTML={{ __html: state.info_privacy }}></div>,
    //             closable: true,
    //             maskClosable: true,
    //         });
    //     }
    // };

    const informativaModal = () => {
        if (state) {
            Modal.info({
                title: 'Informativa Privacy',
                width: innerWidth < 500 ? '95%' : '60%',
                style: {
                    maxWidth: 1000,
                },
                content: (
                    <div style={{ fontFamily: 'Poppins-Light', fontSize: 16, marginBottom: 20, maxHeight: '70vh', overflowY: 'auto' }}>
                        <div style={{ marginTop: 0 }} dangerouslySetInnerHTML={{ __html: state.info_privacy }} />
                    </div>
                ),
                closable: true,
                maskClosable: true,
            });
        }
    };

    const privatoConsumatoreModal = () => {
        if (state) {
            Modal.info({
                title: 'Privato Consumatore',
                width: innerWidth < 500 ? '95%' : '60%',
                style: {
                    maxWidth: 1000,
                },
                content: (
                    <div style={{ fontFamily: 'Poppins-Light', fontSize: 16, marginBottom: 20, maxHeight: '70vh', overflowY: 'auto' }}>
                        <div style={{ marginTop: 0 }} >
                            Il Codice del Consumo, all'art. 3 definisce il consumatore come “la persona fisica che agisce per scopi estranei all'attività imprenditoriale, commerciale, artigianale o professionale eventualmente svolta"
                        </div>
                    </div>
                ),
                closable: true,
                maskClosable: true,
            });
        }
    };

    return (
        <TopBarHome>
            <div className="pol-content" >
                <div style={{
                    color: '#003897', fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 18 : 24, marginLeft: 15, marginRight: 15,
                    marginBottom: 60, marginTop: 50, display: 'flex', justifyContent: 'center', textAlign: 'center'
                }}>
                    Se hai più di 18 anni e sei residente in Italia, prima di cominciare:
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 60 }}>
                    <img src={conditionsImg} alt="Banco Azzoaglio" width={'100%'} height={'100%'} style={{ maxWidth: innerWidth < 500 ? 274 : 550 }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: innerWidth < 500 ? 'column' : 'row', width: '70%', justifyContent: 'space-between' }}>
                        <div style={{
                            borderRadius: 20, margin: 20, fontFamily: 'Poppins-Regular', fontSize: 16, textAlign: 'center', maxWidth: 400,
                            backgroundColor: '#EFF4FD', padding: 15, boxShadow: "-3px 3px 10px #d2d6df", minHeight: 150, paddingTop: 30
                        }}>
                            Ricordati di tenere a portata di mano il documento d'identità e la tessera sanitaria del richiedente.
                        </div>
                        <div style={{
                            borderRadius: 20, margin: 20, fontFamily: 'Poppins-Regular', fontSize: 16, textAlign: 'center', maxWidth: 400,
                            backgroundColor: '#EFF4FD', padding: 15, boxShadow: "-3px 3px 10px #d2d6df", minHeight: 150, paddingTop: 30
                        }}>
                            Per una migliore esperienza, utilizza un dispositivo recente dotato di fotocamera o webcam.
                            <br />
                            <span onClick={requisitiModal}
                                style={{ color: '#003897', textDecoration: 'underline', cursor: 'pointer' }}>Vedi Requisiti</span>
                        </div>
                        <div style={{
                            borderRadius: 20, margin: 20, fontFamily: 'Poppins-Regular', fontSize: 16, textAlign: 'center', maxWidth: 400,
                            backgroundColor: '#EFF4FD', padding: 15, boxShadow: "-3px 3px 10px #d2d6df", minHeight: 150, paddingTop: 30
                        }}>
                            Potrai interrompere in qualunque momento e accedere nuovamente attraverso il codice inviato alla tua email.
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'row', width: '70%', justifyContent: 'space-between' }}>
                        <div style={{ fontFamily: 'Poppins-Medium', }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 15 }}>
                                <Checkbox onChange={onChange} />
                                <div style={{ fontSize: 17, marginLeft: 10 }}>Dichiaro di aver preso visione dell’
                                    <span style={{ color: '#003897', textDecoration: 'underline', cursor: 'pointer' }}
                                        onClick={informativaModal}>informativa privacy</span></div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 15 }}>
                                <Checkbox onChange={onChangeFea} />
                                <div style={{ fontSize: 17, marginLeft: 10 }}>Dichiaro di aver preso visione dell'
                                    <a href="https://www.azzoaglio.it/ckfinder/userfiles/files/Trasparenza/GDPR/Informativa_FEA_con_OTP.pdf" target="_blank" style={{ color: '#003897', textDecoration: 'underline', cursor: 'pointer' }}>
                                        Informativa firma elettronica avanzata (FEA) con OTP
                                    </a>
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 15 }}>
                                <Checkbox onChange={onChangeTrasparenza} />
                                <div style={{ fontSize: 17, marginLeft: 10 }}>Dichiaro di aver preso visione dei<span> </span>
                                    <span style={{ color: '#003897', textDecoration: 'underline', cursor: 'pointer' }}
                                        onClick={trasparenzaModal}>documenti relativi alla Trasparenza</span></div>
                            </div>
                            {state && state.flg_privato &&
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 15 }}>
                                    <Checkbox onChange={onChangePrivato} />
                                    <div style={{ fontSize: 17, marginLeft: 10 }}>Dichiaro di richiedere l'apertura del rapporto come<span> </span>
                                        <span style={{ color: '#003897', textDecoration: 'underline', cursor: 'pointer' }}
                                            onClick={privatoConsumatoreModal}>privato consumatore</span></div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20, marginBottom: 20 }}>

                    <Button
                        type="primary"
                        style={{ fontFamily: 'Poppins-SemiBold', fontSize: 16, height: 40, borderRadius: 20, backgroundColor: '#003897', borderWidth: 0, margin: 20, width: 110 }}
                        onClick={backHandler}>
                        INDIETRO </Button>
                    {conditionState && conditionPrivato && conditionTrasparenza && conditionFEA &&
                        <Button
                            type="primary"
                            style={{ fontFamily: 'Poppins-SemiBold', fontSize: 16, height: 40, borderRadius: 20, backgroundColor: '#003897', borderWidth: 0, margin: 20, width: 110 }}
                            onClick={buttonHandler}>AVANTI</Button>
                    }
                    {(!conditionState || !conditionPrivato || !conditionTrasparenza || !conditionFEA) &&

                        <Button
                            type="primary"
                            style={{
                                fontFamily: 'Poppins-SemiBold', fontSize: 16, height: 40, borderRadius: 20, borderColor: '#898d8f', backgroundColor: 'white',
                                borderWidth: 1, margin: 20, width: 110, color: '#898d8f', cursor: 'not-allowed'
                            }}>
                            AVANTI </Button>
                    }
                </div>
            </div>
        </TopBarHome >
    );
};

export default ConditionScreen;
